module.exports = __webpack_public_path__ + "img/rays_divider07.c7ee7463.jpg";